import { createSelector } from 'reselect';

const getDadata = state => state.Authorization.dadata.selected;

export const selectDadataSelected = createSelector(
  [getDadata],
  obj => {
    let retObj = {};
    if (Object.keys(obj).length > 0) {
      retObj = {
        name_legal: obj.name,
        address_legal: obj.address,
        birth_date: obj.dateRegistered,
        inn: obj.inn,
      };
      if (obj.inn.length === 12) {
        retObj = { ...retObj, ogrnip: obj.ogrn };
      } else {
        retObj = { ...retObj, kpp: obj.kpp, ogrn: obj.ogrn };
      }
    }
    return retObj;
  }
);
